import React from "react";
import { Link } from "react-router-dom";

const Forbidden = ({ missing }) => {
  return (
    <div style={{
      minHeight: "60vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: "1.5rem",
    }}>
      <div className="bl-glass" style={{ padding: "2rem", maxWidth: 480, width: "100%", textAlign: "center" }}>
        <div style={{
          width: 56, height: 56, borderRadius: 999,
          background: "rgba(var(--bl-accent-rgb), 0.12)",
          border: "1px solid var(--bl-line-strong)",
          display: "inline-flex", alignItems: "center", justifyContent: "center",
          marginBottom: "1rem",
        }}>
          <i className="ri-lock-2-line" style={{ fontSize: 24, color: "var(--bl-accent-light)" }}></i>
        </div>
        <h1 style={{
          margin: 0,
          fontFamily: "var(--bl-font-display)",
          fontSize: "1.4rem",
          color: "#fff",
          letterSpacing: "-0.01em",
        }}>
          You don't have access to this page
        </h1>
        <p style={{ marginTop: "0.75rem", color: "var(--bl-text-prose)", fontSize: 14 }}>
          Your account doesn't include the permission required.
          {missing ? (
            <>
              {" "}Missing:{" "}
              <code style={{
                fontFamily: "var(--bl-font-mono)",
                fontSize: 12,
                background: "rgba(var(--bl-accent-rgb), 0.16)",
                color: "var(--bl-accent-light)",
                padding: "2px 6px",
                borderRadius: 4,
              }}>{missing}</code>
            </>
          ) : null}
        </p>
        <p style={{ marginTop: 4, color: "var(--bl-text-soft)", fontSize: 14 }}>
          Contact a super-admin if you think this is a mistake.
        </p>
        <Link to="/overview" className="bl-btn-primary" style={{ marginTop: "1.5rem", textDecoration: "none" }}>
          Back to overview
        </Link>
      </div>
    </div>
  );
};

export default Forbidden;
